const WebSerialDisplayControl = require("./WebSerialDisplayControl");

let displayControlEnabled = null;
let volumeControlEnabled = null;

const service = {};

const performSerialPortsCheck = () => {
  // Only if both display and volume control are disabled, we should forget the serial ports
  if( displayControlEnabled === false && volumeControlEnabled === false ) {
    console.log( "Requesting to forget serial ports because both display and volume control are disabled" );

    WebSerialDisplayControl.forgetAllPorts();
  }
}

service.setDisplayControlEnabled = value => {
  displayControlEnabled = value;

  performSerialPortsCheck();
}

service.setVolumeControlEnabled = value => {
  volumeControlEnabled = value;

  performSerialPortsCheck();
}

service.clean = () => {
  displayControlEnabled = null;
  volumeControlEnabled = null;
}

module.exports = service;
